import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TheFireTheFlour() {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setOffset(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="24430" id="the-ambush-slider" className="dark bg-background text-foreground relative h-screen w-full overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/30 z-10" /> {}
        <video autoPlay loop muted playsInline className="h-full w-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/claypot_chicken_hero.png">
          <source src="/video/taiwan_food_sizzle.mp4" type="video/mp4" />
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/claypot_chicken_hero.png" alt="Bubbling Taiwan Claypot Chicken and Sizzling Hotplates" className="h-full w-full object-cover" />
        </video>
      </div>

      {}
      <div className="relative z-20 flex h-full flex-col items-center justify-center px-4 text-center" style={{
      transform: `translateY(${offset * 0.3}px)`
    }}>
        <h1 className="font-sans text-6xl font-black uppercase leading-none tracking-tighter text-white drop-shadow-[0_8px_16px_rgba(230,57,70,0.8)] sm:text-8xl md:text-9xl lg:text-[120px]">
          Great Taipei 大台北
        </h1>
        
        <p className="mt-6 max-w-2xl font-sans text-xl font-extrabold italic text-accent drop-shadow-lg animate-pulse sm:text-2xl md:text-3xl">
          Taiwan’s Best Claypot. Hear the Sizzle.
        </p>

        <div className="mt-10 sm:mt-14">
          <Link to="/GreatTaipeiPage">
            <Button size="lg" className="h-14 rounded-full bg-primary px-10 text-lg font-black uppercase tracking-widest text-primary-foreground shadow-[0_0_25px_rgba(230,57,70,0.6)] transition-transform hover:scale-110 hover:bg-primary/90 hover:shadow-[0_0_40px_rgba(230,57,70,0.8)]">
              Explore the Menu
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 z-20 -translate-x-1/2 animate-bounce text-white/80">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 5v14" />
          <path d="m19 12-7 7-7-7" />
        </svg>
      </div>
    </section>;
}